import { adminRequest } from './adminApi'

export interface AdminDashboardUsers {
  total: number
  internal: number
  admin: number
}

export interface AdminDashboardGeneration {
  pending: number
  running: number
  done: number
  failed: number
  partial_result: number
  needs_review: number
  success_rate: number
  partial_rate: number
  avg_latency_ms: number
}

export interface AdminDashboardLLMHealth {
  model_alias: string
  count: number
  success_rate: number
  avg_latency_ms: number
  p90_latency_ms: number
  tps: number
  baseline_tps: number
  degraded: boolean
  sample_count: number
  baseline_sample_count: number
}

export interface AdminDashboardRoleRoutable {
  role: string
  routable: boolean
}

export interface AdminDashboardBackendHealth {
  ok: number
  failed: number
  unknown: number
}

export interface AdminDashboardStorage {
  backend: string
  buckets: Record<string, string>
}

export interface AdminDashboardSummary {
  users: AdminDashboardUsers
  generation: AdminDashboardGeneration
  llm_health: AdminDashboardLLMHealth[]
  role_routable: AdminDashboardRoleRoutable[]
  backend_health: AdminDashboardBackendHealth
  storage: AdminDashboardStorage
}

export interface AdminDashboardAlert {
  id: string
  severity: 'critical' | 'warning' | string
  title: string
  detail: string
  value: number
  queue?: string
}

export interface AdminDashboardQueue {
  queue: string
  ready: number
  leased: number
  dead: number
  failure_dominant: string
  failure_share: number
  failure_samples: number
}

export interface AdminDashboardTTSFallback {
  configured: boolean
  primary_failures: number
  fallback_served: number
}

export interface AdminDashboardAlertsResponse {
  alerts?: AdminDashboardAlert[]
  queues?: AdminDashboardQueue[]
  tts_fallback?: AdminDashboardTTSFallback
  checked_at?: number
}

export function getDashboardSummary(): Promise<AdminDashboardSummary> {
  return adminRequest<AdminDashboardSummary>('/v1/admin/dashboard/summary')
}

export function getDashboardAlerts(): Promise<AdminDashboardAlertsResponse> {
  return adminRequest<AdminDashboardAlertsResponse>('/v1/admin/dashboard/alerts')
}
